export class Interpolation {
    static EasInOutInstant(x: number) {
        return x < 0.5 ? 0 : 1;
    }

    static EaseInOutQuad(x: number) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
    }

    static EaseInOutQuart(x: number) {
        return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
    }

    static Clamp(value: number, min: number, max: number) {
        return Math.min(Math.max(min, value), max);
    }

    static Lerp(initialValue: number, finalValue: number, progress: number) {
        progress = this.Clamp(progress, 0, 1);
        return initialValue + (finalValue - initialValue) * progress;
    }
}
